__turbopack_context__.v({
  "grid": "PageLayout-module__cIqdoa__grid",
  "maxWidthFull": "PageLayout-module__cIqdoa__maxWidthFull",
  "maxWidthLg": "PageLayout-module__cIqdoa__maxWidthLg",
  "maxWidthMd": "PageLayout-module__cIqdoa__maxWidthMd",
  "maxWidthSm": "PageLayout-module__cIqdoa__maxWidthSm",
  "maxWidthXl": "PageLayout-module__cIqdoa__maxWidthXl",
  "pageLayout": "PageLayout-module__cIqdoa__pageLayout",
  "spacingComfortable": "PageLayout-module__cIqdoa__spacingComfortable",
  "spacingCompact": "PageLayout-module__cIqdoa__spacingCompact",
  "spacingDefault": "PageLayout-module__cIqdoa__spacingDefault",
  "spacingSpacious": "PageLayout-module__cIqdoa__spacingSpacious",
  "withMargins": "PageLayout-module__cIqdoa__withMargins",
});
